var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "tradingview-widget-container",
    attrs: { id: "tv_chart_container" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }